/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAccessRequestsPageSummaryFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type AccessRequestsPageSummary, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/access-requests/summary
 */
export interface SummaryRequestBuilder extends BaseRequestBuilder<SummaryRequestBuilder> {
    /**
     * The figures in the metric row above the storefront access-request list: how many requests are pending and how many days the oldest has waited; how many were approved in the last 30 days and the 30 before; the average days from request to decision over requests decided in the last 30 days, next to the response goal; and the first-order rate — of buyers approved 30 to 120 days ago, so each has had a full 30 days, the share who placed an order within 30 days of approval — with the same rate for buyers approved 120 to 210 days ago. Rates are fractions between 0 and 1. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AccessRequestsPageSummary>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AccessRequestsPageSummary | undefined>;
    /**
     * The figures in the metric row above the storefront access-request list: how many requests are pending and how many days the oldest has waited; how many were approved in the last 30 days and the 30 before; the average days from request to decision over requests decided in the last 30 days, next to the response goal; and the first-order rate — of buyers approved 30 to 120 days ago, so each has had a full 30 days, the share who placed an order within 30 days of approval — with the same rate for buyers approved 120 to 210 days ago. Rates are fractions between 0 and 1. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SummaryRequestBuilderUriTemplate = "{+baseurl}/api/analytics/access-requests/summary";
/**
 * Metadata for all the requests in the request builder.
 */
export const SummaryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SummaryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAccessRequestsPageSummaryFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
